export default "__VITE_ASSET__DMhn$WOW__"